import { useNavigate } from "@tanstack/react-router";
import { Dispatch, SetStateAction, useState } from "react";

import { type ISidebarMenuItem } from "~/types/agent-types";

interface SidebarMenuItemsProps {
  item: ISidebarMenuItem;
  setIsExpand: Dispatch<SetStateAction<boolean>>;
}

export const SidebarMenuItem = ({
  item,
  setIsExpand,
}: SidebarMenuItemsProps) => {
  const navigate = useNavigate();
  const hasSubMenu =
    Boolean(item?.subMenu) &&
    item?.subMenu?.length !== undefined &&
    item?.subMenu?.length > 0;
  const [isClicked, setIsClicked] = useState(false);

  const handleClick = () => {
    if (item.link) {
      navigate({ to: item.link });
      setIsExpand(false);
    } else {
      setIsClicked(!isClicked);
    }
  };

  return (
    <li className="p-2">
      <button
        onClick={handleClick}
        className="flex items-center justify-between p-3 w-full bg-orange-200 hover:bg-orange-300 rounded-md transition duration-300"
      >
        <span className="font-semibold text-sm">{item.title}</span>
        {hasSubMenu && (
          <img
            src={
              !isClicked
                ? "https://api.iconify.design/mdi:menu.svg"
                : "/images/closeicon.png"
            }
            alt={!isClicked ? "menu icon" : "close icon"}
            height={20}
            width={20}
          />
        )}
      </button>
      {isClicked && hasSubMenu && (
        <ul className="mt-2 ml-4 pl-4 border-l-2 border-orange-300">
          {item?.subMenu?.map((subItem, index) => (
            <SidebarMenuItem
              key={index}
              item={subItem}
              setIsExpand={setIsExpand}
            />
          ))}
        </ul>
      )}
    </li>
  );
};

export const Sidebar = ({
  item,
  setIsExpand,
}: {
  item: ISidebarMenuItem[];
  setIsExpand: Dispatch<SetStateAction<boolean>>;
}) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  return (
    <div>
      <button
        onClick={toggleDrawer}
        className="p-3 bg-green-500 text-white rounded-md fixed top-4 left-4 z-50"
      >
        <img
          src={
            !isDrawerOpen
              ? "https://api.iconify.design/mdi:menu.svg"
              : "https://api.iconify.design/mdi:close.svg"
          }
          alt={!isDrawerOpen ? "menu icon" : "close icon"}
          height={24}
          width={24}
        />
      </button>
      <div
        className={`fixed top-0 left-0 h-full w-64 bg-white shadow-lg border border-gray-200 transition-transform transform ${
          isDrawerOpen ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        <ul className="p-4">
          {item.map((item, index) => (
            <SidebarMenuItem
              key={index}
              item={item}
              setIsExpand={setIsExpand}
            />
          ))}
        </ul>
      </div>
    </div>
  );
};
